import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { userTypeResponse } from 'src/app/shared/constants/response-mapping';
import { AccountSettingsService } from '../account-setting.service';

@Component({
  selector: 'app-delete-account-confirm',
  templateUrl: './delete-account-confirm.component.html',
  styleUrls: ['./delete-account-confirm.component.scss'],
})
export class DeleteAccountConfirmComponent {
  @Input() dialogRef?: any;
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @Output() siteListChange = new EventEmitter<string[]>();

  constructor(
    private localizationService: LocalizationService,
    private accountSettingsService: AccountSettingsService,
    private stateManagementService: StateManagementService
  ) {
    this.localizationService.setupLocalization();
  }

  closeDialog(): void {
    this.dialogRef?.close();
  }

  cancel(): void {
    this.stepperChange.emit((this.stepper = 1));
  }

  confirmDelete(): void {
    const user = this.stateManagementService.getUser();
    const isPma = user?.userType === userTypeResponse[1];

    if (!isPma) {
      this.stepperChange.emit((this.stepper = 8));
      return;
    }

    this.accountSettingsService.checkAccountDeactivationPermission().subscribe({
      next: (res) => {
        if (!res?.isDeactivationAllowed) {
          this.siteListChange.emit(res?.blockingSites ?? []);
          this.stepperChange.emit((this.stepper = 10));
        } else {
          this.stepperChange.emit((this.stepper = 8));
        }
      },
      error: () => {},
    });
  }
}
